// Layout keyed on the region's own `address_format`, served by the backend
// (no more re-deriving it from a hardcoded country list here).
const NUMBER_FIRST_FORMATS = ['us', 'number_city_zip', 'number_zip_city'];
const HAS_STATE_FORMATS = ['us'];

const join = (parts, glue = ' ') =>
  parts.filter((part) => part !== null && part !== undefined && `${part}`.trim() !== '').join(glue);

class AddressHelpers {
  static streetLine({ address, street_name, street_number }, addressFormat) {
    // Callers that already hold a formatted street line (e.g. the maps deep link) pass it as-is.
    if (address) {
      return address;
    }

    return NUMBER_FIRST_FORMATS.includes(addressFormat)
      ? join([street_number, street_name])
      : join([street_name, street_number]);
  }

  static localityLine({ zip_code, city, state }, addressFormat) {
    if (HAS_STATE_FORMATS.includes(addressFormat)) {
      return join([join([city, state], ', '), zip_code]);
    }

    if (addressFormat === 'number_city_zip') {
      return join([city, zip_code], ', ');
    }

    // 'number_zip_city' and 'international' (default): zip before city.
    return join([zip_code, city]);
  }

  static lines(address, addressFormat) {
    return [
      AddressHelpers.streetLine(address, addressFormat),
      AddressHelpers.localityLine(address, addressFormat),
    ].filter(Boolean);
  }

  static format(address, addressFormat) {
    return AddressHelpers.lines(address, addressFormat).join(', ');
  }
}

export default AddressHelpers;
